import Axios from '../Axios';

const Zone = {
	create(data) {
		return Axios.post('/zones', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get('/zones?&limit=' + limit + '&page=' + page + search);
	},
	readOne(id) {
		return Axios.get('/zones/' + id);
	},
	update(id, data) {
		return Axios.put('/zones/' + id, data);
	},
	delete(id) {
		return Axios.delete('/zones/' + id);
	},
};

export default Zone;
